/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1EmployeepostClassStudentsId202,
  DeleteApiV1EmployeepostClassStudentsId401,
  DeleteApiV1EmployeepostClassStudentsId404,
  DeleteApiV1EmployeepostClassStudentsId500,
  DeleteApiV1EmployeepostClassStudentsIdMutationResponse,
  DeleteApiV1EmployeepostClassStudentsIdPathParams,
} from "../../types/employeePostController/DeleteApiV1EmployeepostClassStudentsId.ts";

export const deleteApiV1EmployeepostClassStudentsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1EmployeepostClassStudentsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1EmployeepostClassStudentsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1EmployeepostClassStudentsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1EmployeepostClassStudentsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1EmployeepostClassStudentsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1EmployeepostClassStudentsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1EmployeepostClassStudentsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1EmployeepostClassStudentsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1EmployeepostClassStudentsId500>;

export const deleteApiV1EmployeepostClassStudentsIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1EmployeepostClassStudentsId202Schema,
  ) as unknown as ToZod<DeleteApiV1EmployeepostClassStudentsIdMutationResponse>;
